import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

const localesWithAlternativeFont = ['az']

const useBrandClasses = () => {
  const brand = useSelector(state => state?.products?.filterBy?.brand?.toLowerCase() || 'toyota')
  const locale = useSelector(state => state?.i18nL10n?.locale)
  const router = useRouter()
  const pathname = (router.asPath || router.pathname || '/').toLowerCase()

  const isMM21 = pathname.includes('mm21')
  const isLexus = brand === 'lexus'
  const shouldAlt = isLexus && !isMM21 && localesWithAlternativeFont.includes(locale)

  return useMemo(() => {
    const cls = [brand]
    if (isMM21) cls.push('mm21')
    if (shouldAlt) cls.push('alternative')
    return cls
  }, [brand, isMM21, shouldAlt])
}
export default useBrandClasses
